<section class="content-header" style="padding: 5px !important;">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-6">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item active">
            <i class="fas fa-home"></i> &nbsp;Trang chủ
          </li>
          <div class=""></div>
        </ol>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body">
  <div class="card">
    <div class="card-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-default mb-2 float-right" (click)="open(openModal, 'lg', 'Add', '')"><i
                class="fas fa-cog"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="small-box bg-info">
              <div class="inner">
                <h3>{{SV_dang_hoc}}</h3>

                <p>Sinh viên đang học</p>
              </div>
              <div class="icon">
                <i class="fas fa-plane-departure"></i>
              </div>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-6 col-12">
            <div class="small-box bg-success">
              <div class="inner">
                <h3>{{SV_thoi_hoc}}</h3>

                <p>Sinh viên thôi học</p>
              </div>
              <div class="icon">
                <i class="fas fa-chalkboard-teacher"></i>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<div class="row col-md-12">
  <div class="data-table col-md-12">
    <section class="content cus-body">
      <div class="card">
        <div class="card-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-default mb-2 float-right" (click)="open(openModal3, 'lg', 'Add', '')"><i
                    class="fas fa-cog"></i></button>
              </div>
            </div>
            <div id="chartContainer" style="height: 370px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="data-table col-md-12">
    <section class="content cus-body">
      <div class="card">
        <div class="card-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-default mb-2 float-right" (click)="open(openModal2, 'lg', 'Add', '')"><i
                    class="fas fa-cog"></i></button>
              </div>
            </div>
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
              <table class="table table-bordered table-fixed" style="width: 100%;">
                  <thead>
                      <tr *ngFor="let i of dataHeader">
                          <th *ngFor="let value of i.Cells" [attr.colspan]="value.Colspan"
                              [attr.rowspan]="value.Rowspan">
                              {{value.Name}}
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let i of dataTable">  
                          <td *ngFor="let value of i.Value"
                              [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}">
                              {{value.Value}}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #openModal let-modal>
  <div class="modal-header m-header text-center" style="padding-top: 0px; padding-bottom: 0px;">
    <span (click)="modal.dismiss('Cross click')" aria-hidden="true" style="font-size: 25px;">&times;</span>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" [formGroup]="filter">
      <div class="row">
        <div class="col-md-4 ">
          <label>Hệ</label>
          <select class="form-control" (change)="changeHe()" formControlName="ID_he">
            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Học kỳ</label>
          <select class="form-control" formControlName="Hoc_ky">
            <option value="0">Tất cả</option>
            <option value="1">Học kỳ I</option>
            <option value="2">Học kỳ II</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Năm học</label>
          <select class="form-control" formControlName="Nam_hoc">
            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
          </select>
        </div>

      </div>
    </form>



  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;">
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>
<ng-template #openModal2 let-modal>
  <div class="modal-header m-header text-center" style="padding-top: 0px; padding-bottom: 0px;">
    <span (click)="modal.dismiss('Cross click')" aria-hidden="true" style="font-size: 25px;">&times;</span>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" [formGroup]="tableFilter">
      <div class="row">
        <div class="col-md-4 ">
          <label>Hệ</label>
          <select class="form-control" (change)="changeHe2()" formControlName="ID_he">
            <option *ngFor="let i of dataHe2" value="{{i.ID_he}}">{{i.Ten_he}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Học kỳ</label>
          <select class="form-control" formControlName="Hoc_ky">
            <option value="1">Học kỳ I</option>
            <option value="2">Học kỳ II</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Năm học</label>
          <select class="form-control" formControlName="Nam_hoc">
            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
          </select>
        </div>

      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit2()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;">
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>
<ng-template #openModal3 let-modal>
  <div class="modal-header m-header text-center" style="padding-top: 0px; padding-bottom: 0px;">
    <span (click)="modal.dismiss('Cross click')" aria-hidden="true" style="font-size: 25px;">&times;</span>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" [formGroup]="chartFilter">
      <div class="row">
        <div class="col-md-4 ">
          <label>Hệ</label>
          <select class="form-control" (change)="changeHe3()" formControlName="ID_he">
            <option *ngFor="let i of dataHe2" value="{{i.ID_he}}">{{i.Ten_he}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Học kỳ</label>
          <select class="form-control" formControlName="Hoc_ky">
            <option value="1">Học kỳ I</option>
            <option value="2">Học kỳ II</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Năm học</label>
          <select class="form-control" formControlName="Nam_hoc">
            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
          </select>
        </div>

      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit3()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;">
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>